import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { LossMakingSkusPage } from '@/components/Business/LossMakingSkusPage'
import {
  EMPTY_LOSS_MAKING_SEARCH,
  type LossMakingSearch,
  lossMakingSearchSchema,
  withoutLossMakingDefaults,
} from '@/components/Business/lossMakingSearch'

/** Wiring only. The schema lives beside the page in `lossMakingSearch.ts`. */
export const Route = createFileRoute('/_app/business/loss-making-skus')({
  validateSearch: lossMakingSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_LOSS_MAKING_SEARCH)] },
  component: LossMakingSkusRoute,
})

function LossMakingSkusRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<LossMakingSearch>) =>
      void navigate({
        search: (current) => withoutLossMakingDefaults({ ...current, ...next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  )
  return <LossMakingSkusPage search={search} onSearchChange={onSearchChange} />
}
